import React, {Component} from 'react';
import logo from '../../images/logo_dashbo_purple.svg';
import logotipo from '../../images/logotipo_dashbo_purple.svg';
import Background from '../../images/login_bg.jpg';
import LoginAcceptingInvitation from "./LoginAcceptingInvitation";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {TermsAndConditions} from "./TermsAndConditions";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import {Loading} from "../Loading";

let sectionStyle = {
    backgroundImage: `url(${Background})`
};

class AcceptInvitationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agencyName: null,
            email: null,
            loading: true
        };
    }

    componentDidMount() {
        new APIClient(API_URL + 'invitation/' + this.props.match.params.hash).call('GET')
            .then((data) => {
                if (data.status === 'ERROR') {
                    alert(data.error_message);
                    this.props.history.push('/page-not-found');
                } else {
                    this.setState({
                        agencyName: data.data.agency_name,
                        email: data.data.email,
                        loading: false
                    });
                }
            });
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return (
                <div className="app-content">
                    <div className="login-sidebar">
                        <Loading message={t('login.wait')}/>
                    </div>
                    <AcceptInvitationCover/>
                </div>
            );
        }

        return (
            <div className="app-content">
                <AcceptInvitationSidebar
                    hash={this.props.match.params.hash}
                    agencyName={this.state.agencyName}
                    t={t}
                />
                <AcceptInvitationCover/>
            </div>
        );
    }
}

export default withRouterParams(withTranslation()(AcceptInvitationComponent));

export class AcceptInvitationSidebar extends Component {
    render() {
        const { t, agencyName } = this.props;
        return (
            <div className="login-sidebar invitation-sidebar">
                <img src={logo} className="app-logo" alt="logo"/>
                <img src={logotipo} className="app-logo-name" alt="logotipo"/>
                <p className="tagline">{t('login.tagline')}</p>
                <div className="invitation-context">
                    <p className="invitation-title">{t('login.invitation_title')}</p>
                    <p className="invitation-agency-name">{agencyName}</p>
                    <p className="invitation-description">{t('login.invitation_description')}</p>
                </div>
                <LoginAcceptingInvitation hash={this.props.hash}/>
                <TermsAndConditions/>
            </div>
        );
    }
}

export class AcceptInvitationCover extends Component {
    render() {
        return (
            <div className="login-content cover" style={sectionStyle}>
            </div>
        );
    }
}
